module.exports = __webpack_public_path__ + "static/img/Deyubg_01.25f19653.jpg";